import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-screen-stream-panel',
  templateUrl: './shared-screen-stream-panel.component.html',
  styleUrl: './shared-screen-stream-panel.component.scss'
})
export class SharedScreenStreamPanelComponent implements OnInit {
  constructor(){

  }

  ngOnInit(): void {
    
  }

}
